import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class DepartmentModel extends BaseModel {
  uuid = '';
  name = {};
  key = '';
  categories = [];
  branches_uuids = [];
  specialists_uuids = [];
  specialists = [];
  thumbnail_image_uuid = null;
  marketing_group_uuid = null;

  static TRANSLATABLE_FIELDS = ['name'];

  rules = {
    name: 'required|max:55',
    key: 'required'
  };

  attributeLabels = {
    uuid: i18n.t('UUID'),
    key: i18n.t('Key'),
    name: i18n.t('Name'),
    branches_uuids: i18n.t('Branches'),
    specialists_uuids: i18n.t('Specialists'),
    marketing_group_uuid: i18n.t('Group Name'),
  };

  constructor(data = {}) {
    if (data.specialists && data.specialists.length > 0) {
      data.specialists_uuids = data.specialists.map(s => s.uuid)
    }
    if (data.branches && data.branches.length > 0) {
      data.branches_uuids = data.branches.map(s => s.uuid)
    }
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(DepartmentModel);


